module.exports = __webpack_public_path__ + "static/media/mdir-logo-hvit.df1e81a3.svg";